import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import { Id } from "PFTypes/id";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./saml_config_row_actions.module.scss";

type SamlConfigRowActionsProps = {
  id: Id;
  active: boolean;
  onActivate: () => void;
  onDelete: () => void;
};

const SamlConfigRowActions = ({
  id,
  active,
  onActivate,
  onDelete
}: SamlConfigRowActionsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={css.buttons}>
      <Button kind={active ? "secondary" : "danger"} small onClick={onActivate}>
        {active ? t("active") : t("inactive")}
      </Button>
      <ButtonLink kind="secondary" small href={`/admin/saml_configs/${id}/edit`}>
        {t("edit")}
      </ButtonLink>
      <Button kind="danger" small onClick={onDelete}>
        {t("remove")}
      </Button>
    </div>
  );
};

export default SamlConfigRowActions;
